import type { EventMeta, EventProvider, GlobalContext } from '../types.ts'

export interface AmplitudeInstance {
  logEvent(eventName: string, eventProperties?: Record<string, unknown>): void
}

export function amplitudeProvider(instance: AmplitudeInstance): EventProvider {
  return {
    name: 'amplitude',
    send(
      event: EventMeta,
      data: Record<string, unknown>,
      context: GlobalContext,
    ) {
      const config = event.backends.amplitude
      if (!config) return

      const nonPHIKeys =
        typeof config === 'object' ? config.nonPHIKeys : undefined
      const payload: Record<string, unknown> = nonPHIKeys
        ? pick(data, nonPHIKeys)
        : { ...data }

      payload.hashedEncounterId = context.hashedEncounterId
      payload.hashedPatientId = context.hashedPatientId
      payload.service = context.service
      payload.version = context.version
      payload.user_group = context.userGroups
      payload.user_group_id = context.userGroupIds

      instance.logEvent(event.name, payload)
    },
  }
}

function pick(
  obj: Record<string, unknown>,
  keys: readonly string[],
): Record<string, unknown> {
  const result: Record<string, unknown> = {}
  for (const key of keys) {
    if (key in obj) {
      result[key] = obj[key]
    }
  }
  return result
}
